<template>
  <div id="booking-widget">
    <div v-show="loader">
      <div class="room-slider room-full-slider">
        <carousel :autoplay="true" :nav="false" :loop="true" :margin="10"
          :responsive="{0:{items:1},600:{items:3},1000:{items:3}}" v-if="images.length>1">
          <!-- <div v-for="(image,i) in images" :key="i"> -->
          <div v-for="(img, index) in images" :key="index">
            <img :src="img"> <!-- <img :src="img.picture" :alt="img.title" > -->
          </div>
        </carousel>
        <div v-for="i in [currentIndex]" :key="i" class="gradient-overlay page-slider" v-else>
          <figure>
            <img :src="currentImg" class="responsive" />
          </figure>
        </div>
      </div>
      <!-- main page -->
      <main class="room-view">
        <div class="container">

          <div class="room-title-details row">
            <div class="col-md-7">
              <h2 class="">{{roomData.name}}</h2>
            </div>
            <div class="col-md-5 pull-right">
              <button class="btn btn-solid" type="button" aria-expanded="false" aria-controls="reservation"
                @click="scrollToElement">Book Your stay</button>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="row" v-if="roomData.description !=''">
                <div class="col-md-7">
                  <strong>About</strong>
                  <p v-html="roomData.description"></p>
                </div>
                <div class="col-md-5">
                  <div v-for="board in roomData.boards" :key="board.name">
                    <strong>{{board.name}} includes:</strong>
                    <p>{{board.description}}</p>
                  </div>
                  <div>
                    <div class="icon"><i class="fa fa-user" aria-hidden="true"></i>
                      <span>{{occupancy.maximumAdultOccupancy}} max</span>
                    </div>
                  </div>
                </div>
              </div>
              <!--row-->
              <div class="row" v-else>
                <div class="col-md-7" v-for="board in roomData.boards" :key="board.name">
                  <strong>{{board.name}} includes:</strong>
                  <p>{{board.description}}</p>
                </div>
                <div class="col-md-5">
                  <div class="icon"><i class="fa fa-user" aria-hidden="true"></i>
                    <span>{{occupancy.maximumAdultOccupancy}} max</span>
                  </div>
                </div>
              </div>
              <!--row-->
            </div>
            <!--LEFT-->
            <div class="col-md-12  h-100">
              <strong>Room Features</strong>
              <div class="vue-icons">
                <div class="row" style="text-align:left;">
                  <div class="col-md-3 col-sm-3" v-for="(feature, index) in roomData.features" :key="index">
                    <div><i class="fa fa-check"></i> <span> {{ feature.name }}</span></div>
                  </div>
                </div>
                <!-- <ul>
                  <li><i class="fa fa-user" aria-hidden="true"></i> <span>{{occupancy.maximumAdultOccupancy}} max</span></li>
                  <li v-for="(feature, index) in roomData.features" :key="index">
                    <i class="fa fa-check"></i>  <span> {{ feature.name }}</span>
                  </li>
                </ul> -->
              </div>
            </div>
            <!--RIGHT-->
          </div>
        </div>
        <!--FORM-->
        <section class="reservation-form">
          <div class="container">
            <div class="room reservation">
              <div class="section-title">
                <h2>Make Reservation</h2>
              </div>
              <div class="room-details">

                <div id="booking-form" v-if="roomsAvailable > 0">
                  <form>
                    <div class="row">
                      <!-- DATE -->
                      <div class="col-md-6">
                        <div class="form-group">
                          <div class="row">
                            <div class="col-md-6 mgb-m-15">
                              <label>Checkin Date</label>
                              <CheckinDate :propertyId="this.property_id"
                                :stayrestrictions="this.bookings.data && this.bookings.data[this.propertyid] ? this.bookings.data[this.propertyid].stay_restrictions : []"
                                @checkin-date-changed="updateAllOccupancyDates('checkin_date', checkinDate)">
                              </CheckinDate>
                            </div>
                            <div class="col-md-6">
                              <label>Checkout Date </label>
                              <CheckoutDate
                                @checkout-date-changed="updateAllOccupancyDates('checkout_date', checkoutDate)">
                              </CheckoutDate>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--ROOMS-->
                      <div class="col-md-6">
                        <div class="form-group">
                          <div class="row">
                            <div class="col-md-6">
                              <label>{{roomLabel.singular.charAt(0).toUpperCase() +
                                roomLabel.singular.slice(1)}}</label>
                              <select class="form-control" id="single-garden-selection" tabindex="-98" v-model="room">
                                <option value="0">Select {{roomLabel.singular}}</option>
                                <option :value="rmindex + 1" v-for="(rm, rmindex) in getAvailableRoom(roomsAvailable)"
                                  :key="rmindex">{{rmindex + 1}} <span
                                    v-if="rmindex + 1 > 1">{{roomLabel.plural}}</span><span
                                    v-else>{{roomLabel.singular}}</span></option>
                              </select>
                            </div>
                            <div class="col-md-6">
                              <label>Coupon Code</label>
                              <input class="vue-email_screen sd form-control " v-model="couponCode" id="coupon_code"
                                name="coupon_code" type="text">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div id="single-garden-selection-toggle" v-for="(room, rindex) in parseInt(room)" :key="rindex">
                      <div class="board-select">
                        <h2 class="uppercase">{{roomLabel.singular}} #{{rindex + 1}}</h2>
                        <div class="row">
                          <div>

                          </div>
                          <!-- ADULTS -->
                          <div class="col-md-3">
                            <label>Adults</label>
                            <!-- {{occupancy}} -->
                            <div class="form-group">

                              <select class="form-control" :id="'adults' + rindex" @click="updateRoomOccupancy(rindex)">
                                <option value="0">Select Adult</option>
                                <!-- <option value="1" >1 Adult</option> -->
                                <option :value="oindx + 1"
                                  v-for="(occupant, oindx) in parseInt(occupancy.maximumAdultOccupancy)" :key="oindx">
                                  {{oindx + 1}} <span v-if="oindx + 1 > 1">Adults</span> <span v-else>Adult</span>
                                </option>
                                <!-- <option value="3">3 Adults</option>
                                                        <option value="4">4 Adults</option>
                                                        <option value="5">5 Adults</option> -->
                              </select>
                            </div>
                          </div>
                          <!-- Children -->
                          <div class="col-md-3" v-if="ageGroupsDetails.children_allowed != 0">
                            <label>Children</label>
                            <div class="form-group">
                              <select class="form-control" :id="'children' + rindex"
                                @click="updateRoomOccupancy(rindex)" @change="createAgeDivs(rindex)">
                                <option value="0">Select Child</option>
                                <option :value="ocindx + 1"
                                  v-for="(choccupant, ocindx) in parseInt(occupancy.maximumChildOnlyOccupancy)"
                                  :key="ocindx">{{ocindx + 1}} <span v-if="ocindx + 1 > 1">Children</span> <span
                                    v-else>Child</span></option>
                              </select>
                            </div>
                            <div v-if="childAgeDiv.filter((x) => x.id == rindex).length > 0">
                              <div v-for="(n, indx) in childAgeDiv.filter((x) => x.id == rindex)" :key="indx">
                                <div v-for="(child, chindx) in parseInt(n.children)" :key="chindx">
                                  <label>Child {{chindx + 1}}</label>
                                  <select :id="'childages' + rindex" name="child_1_age" class="child_ages rounded5"
                                    v-on:change="updateChildAges($event,rindex,chindx)">
                                    <option value="">Age</option>
                                    <option
                                      v-for="(childrenagerange, ageindex) in computeChildrenAgeRange(ageGroupsDetails)"
                                      :key="ageindex" :value="childrenagerange.age">{{childrenagerange.age}} yrs
                                    </option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Children -->
                          <!-- babies -->
                          <div class="col-md-3" v-if="ageGroupsDetails.babies_allowed != 0">
                            <label>Infants</label>
                            <div class="form-group">

                              <select class="form-control" :id="'babies' + rindex" @click="updateRoomOccupancy(rindex)">
                                <option value="0">Select Infants</option>
                                <option value="1">1 Infant</option>
                                <option value="2">2 Infants</option>
                                <option value="3">3 Infants</option>
                                <option value="4">4 Infants</option>
                                <option value="5">5 Infants</option>
                              </select>
                            </div>
                          </div>
                          <!-- end babies -->
                          <div class="col-md-3">
                            <label>Meal Plan</label>
                            <div class="form-group">
                              <select class="form-control" :id="'mealplan' + rindex"
                                @click="updateRoomOccupancy(rindex)">
                                <option v-for="board in roomData.boards" :key="board.name" :value="board.name">
                                  {{board.name}}</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!--board-select-->
                    </div>

                    <div class="sub-total">
                      <div class="row">
                        <div class="col-md-12" style="margin-bottom:15px;">
                          <div class="form-check" v-if="!residenceTab">
                            <label>
                              <input type="radio" name="residency" value="resident" id="resident" checked
                                @click="proofNonRes('resident')">
                              <span class="checkmark">Resident</span>
                            </label>

                            <label>
                              <input type="radio" name="residency" value="non-resident" id="resident"
                                @click="proofNonRes('non-resident')">
                              <span class="checkmark">Non Resident</span>
                            </label>
                            <!-- <input class="form-check-input" type="checkbox" value="" id="residency" @click="proofNonRes()">
                                                <label class="form-check-label" for="resident" >
                                                    I am not an East African resident
                                                </label> -->
                          </div>
                        </div>
                        <!--<div class="col-md-3 offset-1">
                                             <span>Sub-Total $ 520.00 </span>
                                        </div>-->
                        <div class="col-md-12" v-if="error == true">
                          <div class="alert alert-danger">
                            <p>{{errormsg}}</p>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div v-show="!showBookingSummary">
                            <button class="btn btn-solid" type="button" @click="checkAvailability" :disabled="clicked">
                              <div v-show="spinner" v-html="searchspinner"></div>
                              <div v-show="!spinner">Check Availability</div>
                            </button>
                          </div>
                          <div v-show="showBookingSummary">
                            <!-- booking summary -->
                            <transition name="fade">
                              <div class="vue_summary_card">
                                <h3>BOOKING SUMMARY</h3>
                                <div class="row">
                                  <div class="col-md-2">
                                    <img id="bedimg" :src="'https://reservations.reserveport.com/static/img/logo.png'"
                                      width="65">
                                    <!-- <i class="fa fa-bed" style="font-size: 38px; color: #007800"></i> -->
                                  </div>
                                  <div class="header-content col-md-10 ol-sm-12 col-12"
                                    style="text-align: left !important">
                                    <span v-if="totalAdult > 0"> <strong>Adult:</strong>&nbsp; {{totalAdult}}</span>
                                    <span v-if="totalChildren > 0"><br><strong> Children:</strong>&nbsp;
                                      {{totalChildren}} </span> <br />
                                    <span><strong>Check-in:</strong>&nbsp;{{ checkinDate }} </span> <br />
                                    <span> <strong>Check-out:</strong>&nbsp;{{ checkoutDate }}</span> <br />
                                  </div>
                                </div>
                                <div class="row sidebar-body">
                                  <div class="col-md-12">
                                    <div>
                                      <table id="room_details_1"
                                        class="table table-striped table-small-font  table-responsive mrgb5"
                                        style="width:100%;">
                                        <thead>
                                          <tr>
                                            <th width="10%" style="text-align: left">
                                              {{bookingData.room_label.singular}} details
                                            </th>
                                            <th width="10%" style="text-align: right">Total</th>
                                          </tr>
                                        </thead>
                                        <tbody v-if="showBookingSummary">
                                          <tr v-for="(mroom, index) in multiRoomResult" :key="index">
                                            <td width="10%" class="prclabel">
                                              {{ mroom.room.name }}
                                            </td>
                                            <td v-if="proofRes === 0" width="10%" valign="middle"
                                              style="text-align: right">
                                              {{ currency.res }} {{ formatPrice(mroom.data.roomPrice.res) }}
                                            </td>
                                            <td v-if="proofRes === 1" width="10%" valign="middle"
                                              style="text-align: right">
                                              {{ currency.nonres }} {{ formatPrice(mroom.data.roomPrice.nonres) }}
                                            </td>
                                          </tr>
                                          <!--  -->
                                          <tr v-if="totalDiscount.res > 0 || totalDiscount.nonres > 0">
                                            <td width="10%" class="prclabel">
                                              <b> Discount</b>
                                            </td>
                                            <td width="10%" valign="middle" style="text-align: right">
                                              <div v-if="proofRes === 0">
                                                {{ currency.res }} {{ formatPrice(totalDiscount.res) }}
                                              </div>
                                              <div v-if="proofRes === 1">
                                                {{ currency.nonres }} {{ formatPrice(totalDiscount.nonres) }}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                    <div>
                                      <table class="table table-striped table-small-font  table-responsive mrgb5"
                                        style="width:100%;">
                                        <tbody>
                                          <tr v-if="serviceCharge.res > 0 || serviceCharge.nonres > 0">
                                            <td width="10%" class="prclabel">
                                              <b> SERVICE CHARGES:</b>
                                              <span class="tool-tip">
                                                <i class="fa fa-info-circle" @mouseover="servicechrg = true"
                                                  @mouseleave="servicechrg = false"></i>
                                              </span>
                                              <div class="tax-tooltip" v-show="servicechrg">
                                                <i class="fa fa-info"></i> <span class="tooltip-header">Service
                                                  Charge</span><br>
                                                <p v-if="proofRes == 0">
                                                  {{bookingData.extra_charges.service_charge.value.res}}% service charge
                                                </p>
                                                <p v-if="proofRes == 1">
                                                  {{bookingData.extra_charges.service_charge.value.nonres}}% service
                                                  charge</p>
                                              </div>
                                            </td>
                                            <td width="10%" valign="middle" style="text-align: right">
                                              <div v-if="proofRes === 0">
                                                <span>{{ currency.res }} {{ formatPrice(serviceCharge.res) }}</span>
                                              </div>
                                              <div v-if="proofRes === 1">
                                                <span>{{ currency.nonres }} {{ formatPrice(serviceCharge.nonres)
                                                  }}</span>
                                              </div>
                                            </td>
                                          </tr>
                                          <tr v-if="totalVat.nonres > 0 || totalVat.res > 0">
                                            <td width="10%" class="prclabel">
                                              <b> TOTAL VAT:</b>
                                              <span class="tool-tip">
                                                <i class="fa fa-info-circle" @mouseover="taxhover = true"
                                                  @mouseleave="taxhover = false"></i>
                                              </span>
                                              <div class="tax-tooltip" v-show="taxhover">
                                                <i class="fa fa-info"></i> <span class="tooltip-header">Total
                                                  VAT</span><br>
                                                <p>{{bookingData.vat.value}}% on rooms, service charges & enhancements
                                                </p>
                                              </div>
                                            </td>
                                            <td width="10%" valign="middle" style="text-align: right">
                                              <div v-if="proofRes === 0">
                                                <span>{{ currency.res }} {{ formatPrice(totalVat.res) }}</span>
                                              </div>
                                              <div v-if="proofRes === 1">
                                                <span>{{ currency.nonres }} {{ formatPrice(totalVat.nonres) }}</span>
                                              </div>
                                            </td>
                                          </tr>
                                          <tr v-if="serviceCharge.nonres > 0 || serviceCharge.res > 0">
                                            <td width="10%" class="prclabel">
                                              <b>{{bookingData.extra_charges.hotel_tax.name}}:</b>
                                            </td>
                                            <td width="10%" valign="middle" style="text-align: right">
                                              <div v-if="proofRes === 0">
                                                <span>{{ currency.res }}</span>
                                                <span>{{ formatPrice(serviceCharge.res) }}</span>
                                              </div>
                                              <div v-if="proofRes === 1">
                                                <span>{{ currency.nonres }}</span>
                                                <span>{{ formatPrice(serviceCharge.nonres) }}</span>
                                              </div>
                                            </td>
                                          </tr>
                                          <tr
                                            v-if="bookingData.extra_charges.gateway_fee_enabled == 1 && totalGatewayFee.res > 0">
                                            <td width="10%" class="prclabel"><b>Total Gateway Fee:</b></td>
                                            <td width="10%" valign="middle" style="text-align: right">
                                              <div v-if="proofRes === 0">
                                                <span>{{ currency.res }}</span>
                                                <span>{{ formatPrice(totalGatewayFee.res) }}</span>
                                              </div>
                                              <div v-if="proofRes === 1">
                                                <span>{{ currency.nonres }}</span>
                                                <span>{{ formatPrice(totalGatewayFee.nonres) }}</span>
                                              </div>
                                            </td>
                                          </tr>
                                          <tr class="pricetotal">
                                            <td width="10%" class="prclabel"><b>Total:</b></td>
                                            <td width="10%" valign="middle" style="text-align: right">
                                              <div v-if="proofRes === 0">
                                                <span>{{ currency.res }}</span>
                                                <span>{{ formatPrice(total.res) }}</span>
                                              </div>
                                              <div v-if="proofRes === 1">
                                                <span>{{ currency.nonres }}</span>
                                                <span>{{ formatPrice(total.nonres) }}</span>
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                    <div class="vat2">
                                      <span class="error">* </span> Price {{bookingData.vat.room_price}} of all govt
                                      taxes
                                    </div>
                                    <div>
                                      <!-- <a class="btn btn-solid" type="button" data-toggle="modal" data-target="#proffmodalpopup" v-if="resident =='resident' && residenceTab == true" @click="openProofModal(multiRoomResult, selectedRooms)">
                                                                            <div>Continue.</div>
                                                                        </a> -->
                                      <a class="btn btn-solid" type="button"
                                        @click="redirectToMultiroomBookDetail(multiRoomResult,selectedRooms)">
                                        <div>Continue</div>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </transition>
                            <!-- end booking summary -->
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--Sub-total-->

                  </form>
                  <!-- modal for proof of residency pop -->
                  <div class="modal" id="proffmodalpopup">
                    <div class="modal-dialog">
                      <div class="modal-content">
                        <!-- Modal body -->
                        <div class="proof_modal_body">
                          Dear Guest, <br><br>
                          <p>Please note that you have selected resident rates</p>
                          <p>As per company policies proof of residency will be required upon check-in</p>
                          <div class="proof_modal_list">
                            <ul>
                              <li>If you do confirm that you are a resident kindly click 'OK' to proceed with your
                                booking</li>
                              <li>If you are a non-resident, kindly click 'CANCEL' and use the resident/non-resident
                                tabs to switch to the non-resident portal</li>
                            </ul>
                          </div>
                        </div>
                        <div class="modal-footer">
                          <div class="btn-toolbar pull-right" role="toolbar" aria-label="Toolbar with button groups">
                            <div class="btn-group mr-2" role="group" aria-label="Second group">
                              <button type="button" id="vue-btn" class="btn btn-outline"
                                data-dismiss="modal">Cancel</button>
                            </div>
                            <div class="btn-group" role="group" aria-label="Third group">
                              <button type="button" class="btn btn-solid" id="vue-btn"
                                @click.prevent="redirectToMultiroomBookDetail(bookingDataProof, boardDataProof)"
                                data-dismiss="modal">OK</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- end -->

                  <div class="policy">
                    <div class="row">
                      <div class="col-md-4" v-if="bookingData.cancellation_policies !==''">
                        <a class="term-link" type="button" data-toggle="collapse" href="#CancellationPolicy"
                          role="button" aria-expanded="false" aria-controls="CancellationPolicy">
                          Cancellation Policy <i class="fa fa-info-circle" aria-hidden="true"></i>
                        </a>
                      </div>

                      <div class="col-md-4" v-if="bookingData.terms !==''">
                        <a class="term-link" type="button" data-toggle="collapse" data-target="#TermsConditions"
                          role="button" aria-expanded="false" aria-controls="TermsConditions">
                          Terms and Conditions <i class="fa fa-info-circle" aria-hidden="true"></i>
                        </a>

                      </div>
                      <div class="col-md-4">
                        <a class="term-link" role="button" @click="redirectToListBooking(propertyid)"> Back to Rooms</a>
                      </div>
                    </div>
                    <div class="row">

                      <div class="collapse multi-collapse" id="CancellationPolicy">
                        <div class="room-card">
                          <p v-html="bookingData.cancellation_policies"></p>
                        </div>
                      </div>

                      <div class="collapse multi-collapse" id="TermsConditions">
                        <div class="room-card">
                          <p v-html="bookingData.terms"></p>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div id="booking-form" v-else>
                  <form>
                    <div class="row">
                      <!-- DATE -->
                      <div class="col-md-6">
                        <label>Check in - Check out</label>
                        <div class="form-group">
                          <div class="row">
                            <div class="col-md-6">
                              <CheckinDate :propertyId="this.property_id"
                                :stayrestrictions="this.bookings.data && this.bookings.data[this.propertyid] ? this.bookings.data[this.propertyid].stay_restrictions : []"
                                @checkin-date-changed="updateAllOccupancyDates('checkin_date', checkinDate)">
                              </CheckinDate>
                            </div>
                            <div class="col-md-6">
                              <CheckoutDate
                                @checkout-date-changed="updateAllOccupancyDates('checkout_date', checkoutDate)">
                              </CheckoutDate>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--ROOMS-->
                      <div class="col-md-6">
                        <!-- <label for="">Check available days</label> -->
                        <div class="form-group">
                          <a class="btn btn-solid" type="button" style="margin-top:30px;" @click="getRoomDetails">
                            <div v-show="isSearching" v-html="searchspinner"></div>
                            <div v-show="!isSearching">Check Availabilty</div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </form>
                  <div class="row soldoutdates">
                    <label class="soldout-lbl">Sold Out on</label>
                    <div v-for="(soldoutdate, soldindex) in RoomsoldOutDates" :key="soldindex" style="display:inline">
                      <span class="soldoutspan">{{soldoutdate}}</span>
                    </div>
                  </div>

                </div>
                <!--availability-form-->

              </div>

            </div>
          </div>
        </section>

      </main>
      <!-- endtest -->
      <!-- carrosel with html and css only -->
      <!-- end -->
    </div>
    <div class="row">
      <div class="act-overlay" v-show="!loader">
        <loader-terms></loader-terms>
      </div>
    </div>
  </div>
</template>

<script>
import reusableData from '../components/mixins/reusableData'
import moment from 'moment'
import loader from '../components/loader.vue'
import carousel from 'vue-owl-carousel'
import CheckinDate from './dates/checkinDate.vue'
import CheckoutDate from './dates/checkoutDate.vue'
import 'vue2-datepicker/index.css'
import { mapState } from 'vuex'

export default {
  components: {
    carousel,
    'loader-terms': loader,
    CheckinDate, CheckoutDate
  },
  data () {
    return {
      images: '',
      timer: null,
      currentIndex: 0,
      checkdate: '',
      checkoutdate1: '',
      room: 0,
      propertyid: '',
      bookings: '',
      proofRes: 0,
      resident: 'resident',
      roomData: '',
      bookingData: '',
      roomid: '',
      occupancy: '',
      roomOccupancy: [],
      childAgeDiv: [],
      childAges: [],
      promo: '',
      taxhover: false,
      roomsAvailable: '',
      multiRoomResult: {},
      selectedRooms: {},
      RoomsoldOutDates: '',
      isSearching: false,
      spinner: false,
      searchspinner: "<i class='fa fa-spinner fa-spin '></i> Searching..",
      resultData: {},
      roomDetailsData: {},
      roomPrice: 0,
      totalRoomPrice: 0,
      subTotal: 0,
      totalGatewayFee: 0,
      roomDiscount: 0,
      totalDiscount: 0,
      total: 0,
      serviceCharge: 0,
      totalVat: 0,
      hotelTax: 0,
      error: false,
      errormsg: '',
      bookingDataProof: '',
      boardDataProof: '',
      couponCode: '',
      totalAdult: 0,
      totalChildren: 0,
      totalBabies: 0,
      servicechrg: false,
      currency: '',
      residenceTab: false,
      ageGroupsDetails: '',
      roomLabel: '',
      loader: false,
      clicked: false
    }
  },
  beforeMount: async function () {
    var hash = document.location.hash
    var urlparameters = hash.split('?')[1]
    var rmid = urlparameters.split('&')[0]
    this.roomid = rmid.split('=')[1]
    var propid = urlparameters.split('&')[1]
    var encodedpropid = propid.split('=')[1]
    var reconstructedpid1 = encodedpropid.split('%3D')
    var reconstructedpid = reconstructedpid1.join('=')
    this.propertyid = atob(reconstructedpid)
    this.getRoomDetails()
    this.couponCode = this.$store.state.promoCode
    this.updateBookingSummaryOn(false)
    // owl carousel
    // checked resident or non-resident by default
  },
  watch: {
    checkinDate () {
      this.error = false
      this.updateBookingSummaryOn(false) //close booking summary
      var nextDate = this.checkinDate
      var stayrestrictions = this.bookings.data[this.propertyid].stay_restrictions
      if (stayrestrictions.length > 0) {
        for (const stayrestriction of stayrestrictions) {
          var startdate = moment(stayrestriction.start_date).subtract(1, 'days').format('YYYY-MM-DD')
          var enddate = moment(stayrestriction.end_date).add(1, 'days').format('YYYY-MM-DD')
          if (moment(this.checkinDate).isBetween(startdate, enddate) === true) {
            var minNights = stayrestriction.minimum_nights
            break
          } else {
            minNights = this.bookings.data[this.propertyid].minimum_nights
          }
        }
      } else {
        minNights = this.bookings.data[this.propertyid].minimum_nights
      }
      var checkoutnextDate = moment(nextDate).add(minNights, 'days').format('YYYY-MM-DD')
      this.checkoutDate = checkoutnextDate
      this.checkoutdate1 = checkoutnextDate
    },
    room() {
      this.updateBookingSummaryOn(false)

      // When room count is lowered, truncate all related arrays/objects to match the new count
      if (this.room > 0) {
        // Truncate roomOccupancy array to match the new room count
        // This is critical because checkAvailability uses roomOccupancy.length
        if (this.roomOccupancy.length > this.room) {
          this.roomOccupancy = this.roomOccupancy.slice(0, this.room);
        }

        // Remove entries beyond the new room count from multiRoomResult object
        if (this.multiRoomResult && typeof this.multiRoomResult === 'object') {
          const keys = Object.keys(this.multiRoomResult).map(Number).filter(k => !isNaN(k));
          keys.forEach(key => {
            if (key >= this.room) {
              delete this.multiRoomResult[key];
            }
          });
        }

        // Remove entries beyond the new room count from selectedRooms object
        if (this.selectedRooms && typeof this.selectedRooms === 'object') {
          const keys = Object.keys(this.selectedRooms).map(Number).filter(k => !isNaN(k));
          keys.forEach(key => {
            if (key >= this.room) {
              delete this.selectedRooms[key];
            }
          });
        }

        // Remove child age div entries for rooms that no longer exist
        if (Array.isArray(this.childAgeDiv)) {
          this.childAgeDiv = this.childAgeDiv.filter(item => item.id < this.room);
        }
      } else {
        // If room count is 0, clear all arrays/objects
        this.multiRoomResult = {};
        this.roomOccupancy = [];
        this.selectedRooms = {};
        this.childAgeDiv = [];
      }

      if (this.room < 1) {
        this.clicked = true
      } else {
        this.clicked = false
      }
    },
    couponCode() {
      this.updateBookingSummaryOn(false)
    }
  },
  computed: {
    checkinDate() {
      return this.$store.state.checkinDate
    },
    currentImg: function () {
      return this.images[Math.abs(this.currentIndex) % this.images.length]
    },
    ...mapState({
      checkinDate: state => state.checkinDate,
      checkoutDate: state => state.checkoutDate,
      showBookingSummary: state => state.bookingSummaryOn
    })
    // 
  },
  methods: {
    disabledRange (date) {
      const mindate = moment(this.checkoutdate1).subtract(1, 'day').format('YYYY-MM-DD')
      return date < new Date(mindate)
    },
    disableDateBeforeToday (date) {
      const todaysDate = moment().subtract(1, 'day').format('YYYY-MM-DD')
      return date < new Date(todaysDate)
    },
    proofNonRes (resident) {
      this.updateBookingSummaryOn(false)
      if (resident === 'non-resident') {
        this.resident = 'non-resident'
        if (this.bookings.data[this.propertyid].currency.res !== '' && this.bookings.data[this.propertyid].currency.nonres === '') {
          this.proofRes = 0
        } else if (this.bookings.data[this.propertyid].currency.res === '' && this.bookings.data[this.propertyid].currency.nonres !== '') {
          this.proofRes = 1
        } else {
          this.proofRes = 1
        }
      }
      if (resident === 'resident') {
        this.resident = 'resident'
        if (this.bookings.data[this.propertyid].currency.res !== '' && this.bookings.data[this.propertyid].currency.nonres === '') {
          this.proofRes = 0
        } else if (this.bookings.data[this.propertyid].currency.res === '' && this.bookings.data[this.propertyid].currency.nonres !== '') {
          this.proofRes = 1
        } else {
          this.proofRes = 0
        }
      }
    },
    redirectToListBooking (pid) {
      // if it is multi-property redirect differently based on the selected property id
      if (this.$root.multiproperty !== undefined) {
        if (this.$root.multiproperty !== '' && this.$root.multiproperty === true) {
          // this.multipropertyStatus = true
          this.$router.push({
            path: '/?pid=' + btoa(pid)
          })
        } else if (this.$root.multiproperty !== '' && this.$root.multiproperty === false) {
          this.$router.push({
            path: '/'
          })
        } else {
          this.$router.push({
            path: '/?pid=' + btoa(pid)
          })
        }
      } else {
        this.$router.push({
          path: '/'
        })
      }
    },
    getDateDate () {
      let checkinDate = this.getUrlParameter('checkin_date')
      checkinDate = decodeURI(checkinDate)
      let checkouDate = this.getUrlParameter('checkout_date')
      checkouDate = decodeURI(checkouDate)
      if (!checkinDate && !checkouDate) {
        let minimumCheckinNights = this.bookings.data[this.propertyid].minimum_checkin_nights
        let minimumNights = this.bookings.data[this.propertyid].minimum_nights
        if (minimumCheckinNights === 0) {
          let today = moment().format('YYYY-MM-DD')
          if (minimumNights === 0) {
            var tommorow = moment().add(1, 'days').format('YYYY-MM-DD')
          } else {
            tommorow = moment().add(minimumNights, 'days').format('YYYY-MM-DD')
          }
          this.checkoutdate1 = tommorow
          this.checkdate = today
          this.checkinDate = today
          this.checkoutDate = tommorow
        }
        if (minimumCheckinNights > 0) {
          let checkoutRange = minimumCheckinNights + minimumNights
          let futureDate = moment().add(minimumCheckinNights, 'days').format('YYYY-MM-DD')
          let nextdate = moment().add(checkoutRange, 'days').format('YYYY-MM-DD')
          this.checkoutdate1 = nextdate
          this.checkdate = futureDate
          this.checkinDate = futureDate
          this.checkoutDate = nextdate
        }
      } else {
        let checkinDate1 = checkinDate.toString()
        let momentcheckindateObj = moment(checkinDate1, 'YYYY-MM-DD')
        let checkoutDate1 = checkouDate.toString()
        let momentcheckoutdateObj = moment(checkoutDate1, 'YYYY-MM-DD')
        let newDate = momentcheckindateObj.format('YYYY-MM-DD')
        let futureDate = momentcheckoutdateObj.format('YYYY-MM-DD')
        let today = moment().format('YYYY-MM-DD')
        let tommorow1 = moment().add(1, 'days').format('YYYY-MM-DD')
        if (moment(newDate).isBefore(today) === true) {
          this.checkoutdate1 = tommorow1
          this.checkdate = today
          this.checkinDate = today
          this.checkoutDate = tommorow1
        } else {
          if (moment(newDate).isSame(futureDate) === true) {
            var nextDay = moment(newDate).add(1, 'days').format('YYYY-MM-DD')
            this.checkoutdate1 = nextDay
            this.checkdate = newDate
            this.checkinDate = newDate
            this.checkoutDate = nextDay
          } else if (moment(futureDate).isBefore(newDate) === true) {
            var nextDay1 = moment(newDate).add(1, 'days').format('YYYY-MM-DD')
            this.checkoutdate1 = nextDay1
            this.checkdate = newDate
            this.checkinDate = newDate
            this.checkoutDate = nextDay1
          } else {
            this.checkoutdate1 = futureDate
            this.checkdate = newDate
            this.checkinDate = newDate
            this.checkoutDate = futureDate
          }
        }
      }
      if (this.$store.state.rcheckinDate) {
        this.checkoutdate1 = this.$store.state.rcheckoutDate
        this.checkdate = moment().format('YYYY-MM-DD')
        this.checkinDate = this.$store.state.rcheckinDate
        this.checkoutDate = this.$store.state.rcheckoutDate
      }
    },
    updateChildAges (event, index, chindex) {
      this.updateBookingSummaryOn(false)
      this.roomOccupancy[index].children_ages[chindex] = event.target.value
    },
    createAgeDivs (index) {
      var childrenv = document.getElementById('children' + index)
      if (childrenv !== null) {
        var cvalue = childrenv.options[childrenv.selectedIndex].value
        if (this.childAgeDiv.filter((x) => x.id === index).length > 0) {
          this.childAgeDiv[index].children = cvalue
        } else {
          this.childAgeDiv.push({
            id: index,
            children: cvalue
          })
        }
      }
    },
    updateRoomOccupancy (index) {
      this.updateBookingSummaryOn(false)
      this.error = false
      var babiese = document.getElementById('babies' + index)
      var bvalue = 0
      if (babiese !== null) {
        bvalue = babiese.options[babiese.selectedIndex].value
      }

      var adultsv = document.getElementById('adults' + index)
      var avalue = adultsv.options[adultsv.selectedIndex].value

      var cvalue = 0
      var childrenv = document.getElementById('children' + index)
      if (childrenv !== null) {
        cvalue = childrenv.options[childrenv.selectedIndex].value
        //  ensuring maximum room occupancy is not exceeded

        if (parseInt(avalue) !== 0) {
          var remainingAdult = parseInt(this.occupancy.maximumTotalOccupancy) - parseInt(avalue)
          if (remainingAdult === 0) {
            let childreninput = document.getElementById('children' + index)
            childreninput.disabled = true
          } else if (remainingAdult >= 1) {
            let childreninput = document.getElementById('children' + index)
            childreninput.disabled = false
            let op = document.getElementById('children' + index).getElementsByTagName('option')
            for (var i = 0; i < op.length; i++) {
              op[i].disabled = false
              if (op[i].value > remainingAdult) {
                op[i].disabled = true
              }
            }
          }
        } else {
          let childreninput = document.getElementById('children' + index)
          childreninput.disabled = false
          let op = document.getElementById('children' + index).getElementsByTagName('option')
          for (let i = 0; i < op.length; i++) {
            op[i].disabled = false
          }
        }
        if (parseInt(cvalue) !== 0) {
          let remainingChild = parseInt(this.occupancy.maximumTotalOccupancy) - parseInt(cvalue)
          if (remainingChild === 0) {
            let Adultinput = document.getElementById('adults' + index)
            Adultinput.disabled = true
          } else if (remainingChild >= 1) {
            let Adultinput = document.getElementById('adults' + index)
            Adultinput.disabled = false
            let op = document.getElementById('adults' + index).getElementsByTagName('option')
            for (var ai = 0; ai < op.length; ai++) {
              op[ai].disabled = false
              if (op[ai].value > remainingChild) {
                op[ai].disabled = true
              }
            }
          }
        } else {
          let Adultinput = document.getElementById('adults' + index)
          Adultinput.disabled = false
          let op = document.getElementById('adults' + index).getElementsByTagName('option')
          for (let i = 0; i < op.length; i++) {
            op[i].disabled = false
          }
        }
      }

      // end checking room occupancy

      let childAges = []
      if (this.roomOccupancy[index] && this.roomOccupancy[index].children_ages.length > 0) {
        childAges = this.roomOccupancy[index].children_ages
      } else {
        for (let i = 0; i < cvalue; i++) {
          childAges[i] = 0
        }
      }
      // checking if child occupancy has change and filter children ages array
      let childagearrlength = childAges.length
      if (childagearrlength > cvalue) {
        childAges.splice(cvalue)
      }
      var mealplanv = document.getElementById('mealplan' + index)
      var mvalue = mealplanv.options[mealplanv.selectedIndex].value
      var adults = avalue
      var children = cvalue
      var babies = bvalue
      var mealplan = ''
      if (mvalue.toLowerCase() === 'bed only' || mvalue.toLowerCase() === 'bed' || mvalue.toLowerCase() === 'self catering') {
        mealplan = 'BO'
      } else if (mvalue.toLowerCase() === 'bed & breakfast') {
        mealplan = 'BB'
      } else if (mvalue.toLowerCase() === 'half board' || mvalue.toLowerCase() === 'halfboard') {
        mealplan = 'HB'
      } else if (mvalue.toLowerCase() === 'fullboard' || mvalue.toLowerCase() === 'full board') {
        mealplan = 'FB'
      } else if (mvalue.toLowerCase() === 'all inclusive') {
        mealplan = 'AI'
      }
      this.roomOccupancy[index] = { checkin_date: this.checkinDate, checkout_date: this.checkoutDate, room_id: this.roomid, room_count: 1, coupon_code: this.couponCode, adults: adults, babies: babies, children: children, meal_plan: mealplan, children_ages: childAges }
      //
      this.multiRoomResult[index] = {
        id: this.roomid,
        data: '',
        room: this.roomData,
        adult: parseInt(adults),
        children: parseInt(children),
        babies: parseInt(babies),
        boards: mealplan
      }

      // creating array of selected rooms
      this.selectedRooms[index] = {
        id: this.roomid,
        total_adult: adults,
        name: this.roomData.name,
        no_rooms: 1,
        cguest: children,
        children_ages: childAges,
        bguest: babies,
        meal_plan: mealplan,
        totalprice_book: '',
        coupon_details: '',
        daily_rates: {
          total: '',
          adults: '',
          children: '',
          discount: ''
        }
      }
      
      // resetting occupancy number
      this.totalAdult = 0
      this.totalChildren = 0
      this.totalBabies = 0
    },
    clearRoomsData: function () {
      this.selectedRooms = []
    },
    next: function () {
      this.currentIndex += 1
    },
    prev: function () {
      this.currentIndex -= 1
    },
    updateValue: function () {
      console.debug(JSON.stringify(this.values))
      this.$emit('input', this.values)
    },
    getAvailableRoom (availability) {
      // this.updateBookingSummaryOn(false)
      if (availability > 10) {
        var available = 10
      } else {
        available = availability
      }
      return parseInt(available)
    },
    changeCheckoutDate (event) {
      this.error = false
      this.updateBookingSummaryOn(false)
      var nextDate = event.target.value
      var stayrestrictions = this.bookings.data[this.propertyid].stay_restrictions
      if (stayrestrictions.length > 0) {
        for (const stayrestriction of stayrestrictions) {
          var startdate = moment(stayrestriction.start_date).subtract(1, 'days').format('YYYY-MM-DD')
          var enddate = moment(stayrestriction.end_date).add(1, 'days').format('YYYY-MM-DD')
          if (moment(this.checkinDate).isBetween(startdate, enddate) === true) {
            var minNights = stayrestriction.minimum_nights
            break
          } else {
            minNights = this.bookings.data[this.propertyid].minimum_nights
          }
        }
      } else {
        minNights = this.bookings.data[this.propertyid].minimum_nights
      }
      var checkoutnextDate = moment(nextDate).add(minNights, 'days').format('YYYY-MM-DD')
      this.checkoutDate = checkoutnextDate
      this.checkoutdate1 = checkoutnextDate
    },
    computeChildrenAgeRange (ageGroupsDetails) {
      var computedChildAges = []
      for (var i = parseInt(ageGroupsDetails.child_min_age); i <= parseInt(ageGroupsDetails.child_max_age); i++) {
        computedChildAges.push({ 'age': i })
      }

      return computedChildAges
    },
    getRoomDetails: async function () {
      const configUrl = process.env.CONFIG_URL['live_url']
      const key = process.env.PMS_KEY['key']
      const config = {
        headers: { 'Accept': 'application/json' }
      }
      const payload = {
        'property_id': this.propertyid,
        'api': this.type
      }
      const configRes = await this.$http.post(configUrl, payload, config)
      if (configRes.status === 200) {
        let configData = this.CryptoJSAesDecrypt(key, configRes.data.property_details)
        configData = JSON.parse(configData)
        let passkey = configData[0].val_ptoken // process.env.SECRET_KEY[this.propertyid].key
        let consumerKey = configData[0].val_reserveport_secret_key // process.env.CONSUMER_KEY[this.propertyid].key
        const details = JSON.parse(configData[0].add_details)
        let postUrl = details.url
        const postData = {
          checkin_date: this.checkinDate,
          checkout_date: this.checkoutDate,
          room_id: this.roomid
        }
        this.isSearching = true
        var postDataJson = JSON.stringify(postData)
        var encryptedData = this.CryptoJSAesEncrypt(passkey, postDataJson)
        const url = `${postUrl}/index.php?option=com_goreserva_psearch&task=api.searchAvailability&pid=${this.propertyid}&consumer_key=${consumerKey}&data=${encryptedData}`
        this.axios
          .get(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          })
          .then((response) => {
            let responseData = response.data.er
            let decryptedData = this.CryptoJSAesDecrypt(passkey, responseData)
            return JSON.parse(decryptedData)
          })
          .then((data) => {
            this.bookings = data
            this.roomData = data.data[this.propertyid].rooms[this.roomid]
            this.roomLabel = this.bookings.data[this.propertyid].room_label
            this.roomsAvailable = this.roomData.availability.available
            this.occupancy = this.roomData.occupancy
            this.bookingData = data.data[this.propertyid]
            this.currency = this.bookingData.currency
            this.images = this.roomData.images
            this.RoomsoldOutDates = this.roomData.availability.soldOutDates
            this.ageGroupsDetails = this.bookings.data[this.propertyid].age_group_details
            //   starting image sliders
            if (this.images.length > 1) {
              this.timer = setInterval(this.next, 5000)
            }
            if (this.bookings.data[this.propertyid].currency.res !== '' && this.bookings.data[this.propertyid].currency.nonres === '') {
              this.proofRes = 0
              this.residenceTab = true
            } else if (this.bookings.data[this.propertyid].currency.res === '' && this.bookings.data[this.propertyid].currency.nonres !== '') {
              this.proofRes = 1
              this.residenceTab = true
            } else {
              if (this.bookings.data[this.propertyid].guest_form_settings.default_residency === 'res') {
                this.resident = 'resident'
                this.proofRes = 0
              } else if (this.bookings.data[this.propertyid].guest_form_settings.default_residency === 'nonres') {
                this.resident = 'non-resident'
                this.proofRes = 1
              }
            }
            const roompayload = {
              bookingData: data
            }
            this.$store.commit('getRoomBookingData', roompayload)
            this.isSearching = false
            this.loader = true
            this.getDateDate()
          })
          .catch((err) => {
            console.log('error', err)
          })
      }
    },
    scrollToElement () {
      const el = this.$el.getElementsByClassName('reservation')[0]
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' })
      }
    },
    async checkAvailability () {
      this.spinner = true
      this.updateBookingSummaryOn(false)
      let roomName = this.roomLabel.singular.charAt(0).toUpperCase() + this.roomLabel.singular.slice(1)
      const configUrl = process.env.CONFIG_URL['live_url']
      const key = process.env.PMS_KEY['key']
      const config = {
        headers: { 'Accept': 'application/json' }
      }
      const payload = {
        'property_id': this.propertyid,
        'api': this.type
      }
      const configRes = await this.$http.post(configUrl, payload, config)
      if (configRes.status === 200) {
        let configData = this.CryptoJSAesDecrypt(key, configRes.data.property_details)
        configData = JSON.parse(configData)
        let passkey = configData[0].val_ptoken // process.env.SECRET_KEY[this.propertyid].key
        let consumerKey = configData[0].val_reserveport_secret_key // process.env.CONSUMER_KEY[this.propertyid].key
        const details = JSON.parse(configData[0].add_details)
        let postUrl = details.url
        if (this.roomOccupancy.length > 0) {
          let test = ''
          for (var x = 0; x < this.roomOccupancy.length; x++) {
            if (this.roomOccupancy[x] === undefined) {
              test = undefined
              break
            } else if (parseInt(this.roomOccupancy[x].adults) === 0 && parseInt(this.roomOccupancy[x].children) === 0) {
              test = undefined
              break
            } else if (parseInt(this.roomOccupancy[x].adults) === 0 && this.roomOccupancy[x].children === undefined) {
              test = undefined
              break
            } else if (
              (parseInt(this.roomOccupancy[x].children) !== this.roomOccupancy[x].children_ages.length) ||
              this.roomOccupancy[x].children_ages[0] === 0
            ) {
              this.spinner = false
              this.error = true
              this.errormsg = `Please select child ages`
              return
            }
          }

          if (test == undefined) {
            this.spinner = false
            this.error = true
            this.errormsg = `Please select atleast one Adult or one Child occupant of the ${roomName}`
            return
          } else {
          // getting the number of total occupance
            this.clicked = true
            this.error = false
            var postDataJson = JSON.stringify(this.roomOccupancy)
            var encryptedData = this.CryptoJSAesEncrypt(passkey, postDataJson)
            const url = `${postUrl}/index.php?option=com_goreserva_psearch&task=api.calculateRoomPrice&pid=${this.propertyid}&consumer_key=${consumerKey}&data=${encryptedData}`
            await this.axios.get(url, {
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json'
                }
              })
              .then((response) => {
                if (response.data.error === 1) {
                  this.error = true
                  this.errormsg = response.data.msg
                  this.spinner = false
                }
                var responseData = response.data.er
                var decryptedData = this.CryptoJSAesDecrypt(passkey, responseData)
                return JSON.parse(decryptedData)
              })
              .then((data) => {
                if (data.error) {
                  this.error = true
                  this.errormsg = data.msg
                  this.spinner = false
                  this.clicked = false
                } else {
                  this.resultData = data
                  var mealPlan = []
                  for (const mealp of Object.values(this.roomOccupancy)) {
                    mealPlan.push(mealp.meal_plan)
                  }
                  var newmealPlan = [...new Set(mealPlan)]
                  // getting coupon codes available in that room
                  // var couponName = ''
                  var couponDetail = {}
                  for (const coupon of Object.values(this.roomData.discount_coupons)) {
                    couponDetail = {
                      id: coupon.id,
                      code: coupon.code,
                      name: coupon.code,
                      boards: coupon.boards,
                      start_date: coupon.start_date,
                      end_date: coupon.end_date,
                      type: coupon.type
                    }
                    // couponName = coupon.code
                  }
                  var roompricesArr = []
                  for (let i = 0; i < newmealPlan.length; i++) {
                    for (const index of Object.keys(data.totalRoomPrice.rooms[this.roomid][newmealPlan[i]])) {
                      let roomprices = data.totalRoomPrice.rooms[this.roomid][newmealPlan[i]][index]
                      let totalpayble = 0
                      if (this.proofRes === 0) {
                        totalpayble = roomprices.res
                      } else {
                        totalpayble = roomprices.nonres
                      }
                      this.selectedRooms[index].totalprice_book = totalpayble
                      this.selectedRooms[index].coupon_details = JSON.stringify(couponDetail)
                      this.multiRoomResult[index].data = { 'roomName': this.roomData.name, 'roomPrice': roomprices }
                      roompricesArr.push({ 'roomName': this.roomData.name, 'roomPrice': roomprices, 'meal_plan': newmealPlan[i] })
                    }
                  }
                  this.roomDetailsData = roompricesArr
                  // updating prices
                  // this.roomPrice = data.roomPrice
                  this.totalRoomPrice = data.totalRoomPrice
                  this.subTotal = data.subTotal
                  this.totalGatewayFee = data.totalGatewayFee
                  this.roomDiscount = data.roomDiscount
                  this.totalDiscount = data.totalDiscount
                  this.total = data.totalAmountPayable
                  this.serviceCharge = data.totalServiceCharge
                  this.totalVat = data.totalVAT
                  this.hotelTax = data.totalHotelTax
                  // updating prices in store js
                  const payload = {
                    subtotal: this.subTotal,
                    servicecharges: this.serviceCharge,
                    totalvat: this.totalVat,
                    hoteltax: this.hotelTax,
                    total: this.total,
                    discount: this.totalDiscount,
                    GatewayFee: this.totalGatewayFee
                  }
                  // findind the total number of occupancy in that room
                  for (const result of Object.values(this.multiRoomResult)) {
                    // this.totalAdult += result.adult
                    // this.totalChildren += result.children
                    // this.totalBabies += result.babies
                    this.selectedBoard = result.boards
                  }
                  for (const result of Object.values(this.roomOccupancy)) {
                    this.totalAdult = parseInt(result.adults)
                    this.totalChildren = parseInt(result.children)
                    this.totalBabies = parseInt(result.babies)
                  }
                  // end
                  this.$store.dispatch('updatePrices', payload)
                  // spinner
                  // this.childAgeDiv = []
                  this.spinner = false
                  this.clicked = false
                  this.updateBookingSummaryOn(true)
                }
              })
              .catch((err) => {
                console.log('error', err)
              })
          }

          this.updateBookingSummaryOn(true)
        } else {
          this.error = true
          this.spinner = false
          this.errormsg = `Please select atleast one Adult or one Child occupant of the ${roomName}`
        }
      }
    },
    redirectToMultiroomBookDetail (multiBookResult, selectedroom) {
      let payload = {
        selectedmultiroom: selectedroom,
        result: multiBookResult,
        res: this.proofRes,
        checkindate: this.checkinDate,
        checkoutdate: this.checkoutDate
      }
      this.$store.dispatch('gotoMultiRoomBookDetail', payload)
      const payload2 = {
        room: [],
        board: [],
        res: this.proofRes,
        resident: this.resident
      }
      this.$store.dispatch('gotoBookDetail', payload2)
      this.$router.push({
        path: '/multi-room-book-detail/?pid=' + btoa(this.propertyid)
      })
    },
    openProofModal (multiRoomResult, selectedRooms) {
      this.bookingDataProof = multiRoomResult
      this.boardDataProof = selectedRooms
    },
    updateBookingSummaryOn(value) {
      this.$store.dispatch('updateBookingSummaryOn', value)
    },
    updateAllOccupancyDates(key, value) {
      this.updateBookingSummaryOn(false)
      this.totalAdult = 0
      this.totalChildren = 0
      this.totalBabies = 0
      this.room = 0
    }
    // ...mapActions(['updateBookingSummaryOn'])
  },
  mixins: [reusableData],
}
</script>

<style scoped>
#booking-widget {
    font-size: 14px;
}

#booking-widget .vue_summary_card {
    border: 1px solid #CED4DA;
    border-radius: 5px;
    padding: 20px;
    margin-top: 5px;
}

#booking-widget .vue_summary_card h3 {
    font-size: 20px;
    font-weight: 500;
    border-bottom: 1px dotted #dedede;
    padding-bottom: 15px;
    text-align: center;
    color: #555;
    text-transform: uppercase;
    margin-top: 0;
}

/* styling gallery */
#booking-widget .room-title-details {
    position: relative;
    display: block;
    overflow: hidden;
    padding: 0 0 2%
}

#booking-widget .room-full-slider img {
    border-radius: 8px;
}

.eb-col,
.eb-col button {
    min-width: 50%;
}

.vue-icons {
    margin-top: 25px;
}

.term-link {
    color: #973e1c !important;
}

.btn-white-solid {
    background: #fff;
    color: black;
}

.btn-solid {
    background: #FF573D;
    color: #fff;
}

.room-full-slider {
    background: #f5f3f0;
    border-top: 1px solid #ededed;
    border-bottom: 1px solid #ededed;
    padding: 20px 0;
}

#booking-widget .room-card {
    background-color: #fff;
    color: black;
    padding: 15px;
    border: 1px solid #CED4DA;
    border-radius: 5px;
}

/* end styling gallery*/
/* slide two styles */
.fade-enter-active,
.fade-leave-active {
    transition: all 0s ease 0s;
    overflow: hidden;
    visibility: visible;
    position: absolute;
    width: 100%;
    opacity: 1;
}

#booking-widget .proof_modal_body {
    padding: 15px;
}

#booking-widget .proof_modal_list {
    padding-left: 30px;
}

.fade-enter,
.fade-leave-to {
    visibility: hidden;
    width: 100%;
    opacity: 0;
}

.responsive {
    height: 600px;
    max-width: 100%;
    width: 100%;
    /* max-height: calc(100vh - 90px); */
    object-fit: cover;
}

#booking-widget .page-slider {
    max-height: 600px;
}

#booking-widget .page-slider::before {
    display: block;
    content: '';
    position: absolute;
    top: 15px;
    right: 15px;
    bottom: 15px;
    left: 15px;
    /* z-index: 999; */
}

#booking-widget .gradient-overlay {
    position: relative;
}

/* end style 2 */
ul,
li {
    margin: 0;
    padding: 0;
}

.right-bar {
    border: 1px solid #ededed;
    background: #f5f3f0;
    padding-top: 15px;
    padding-bottom: 15px
}

.aligncenter {
    text-align: center;
}

.alignright {
    text-align: right;
}

.alignleft {
    text-align: left;
}

#booking-widget main {
    font-weight: normal;
    width: 100%;
    overflow-x: hidden;
    background: #fff;
    border-top: 1px solid #ededed;
    padding: 100px 0 0;
}

#booking-widget section.reservation-form {
    background: #f5f3f0;
    border-top: 1px solid #ededed;
    border-bottom: 1px solid #ededed;
    margin-top: 30px
}

#booking-widget .section-title {
    width: 100%;
    border-bottom: 1px solid #DDE1E1;
    margin: 3rem 0 3rem;
}

#booking-widget .section-title {
    padding-bottom: 20px;
    position: relative;
}

#booking-widget .room {
    /* padding: 6rem 0 0; */
    position: relative;
    display: block;
    overflow: hidden;
}

#booking-widget .room .section-title {
    padding-top: 20px;
    padding-bottom: 20px;
}

#booking-widget .section-title {
    width: 100%;
    border-bottom: 1px solid #DDE1E1;
    margin: 20px 0;
}

#booking-widget .section-title {
    padding-bottom: 20px;
    position: relative;
}

#booking-widget .section-title:after {
    position: absolute;
    display: block;
    content: '';
    width: 30px;
    height: 1px;
    background: #e3e3e3;
    margin-top: 5px;
}

#booking-widget .room-view .room .room-details {
    margin-bottom: 3rem;
}

#booking-widget .room-details {
    background: #ffffff;
    border-radius: 0 0 5px 5px;
}

#booking-widget .room-view #booking-form {
    padding: 3rem;
}

#booking-widget .policy {
    background: #FFFAEC;
    border-radius: 0px 0px 6px 6px;
    padding: 10px 50px;
    margin: 1.5rem 0 0;
}

#booking-widget .sub-total .btn {
    border-radius: 3px;
    padding: 10px 20px;
}

#booking-widget .room-view .page-header h1 {
    padding-bottom: 1.5rem;
}

#booking-widget .page-header h1 {
    font-weight: 500;
    font-size: 64px;
    line-height: 78px;
}

#booking-widget .uppercase {
    text-transform: uppercase;
}

#booking-widget .board-select h2 {
    font-family: 'Barlow Semi Condensed', sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 18px;
    color: black;
}

#booking-widget #TermsConditions,
#booking-widget #CancellationPolicy {
    margin-top: 10px;
}

#booking-widget .soldoutdates {
    color: #bd362f;
}

#booking-widget .soldoutdates label,
.soldout-lbl {
    color: #bd362f;
    display: block;
    font-weight: 600;
    margin-bottom: 0;
}

#booking-widget .soldoutspan {
    background: #f2dede;
    color: #a94442;
    padding: 5px;
    border: 1px solid #ebccd1;
    display: inline-block;
    vertical-align: middle;
    border-radius: 3px;
    margin: 2px;
    font-size: 12px;
}

@media (max-width: 991.98px) {
    #booking-widget .page-header h1 {
        font-size: 34px;
    }

    #booking-widget .page-header {
        padding: 2rem 0;
    }

    #booking-widget .btn .btn-lg {
        padding: 10px 18px;
        font-size: 18px;
    }

}

@media (max-width: 600px) {
    #booking-widget .room-full-slider {
        padding: 0;
        border: medium none
    }

    #booking-widget main {
        padding: 0;
        border: medium none
    }

    #booking-widget .h2,
    #booking-widget h2 {
        font-size: 1.2rem;
    }

    #booking-widget .room-view #booking-form {
        padding: 1rem
    }

    .mgb-m-10 {
        margin-bottom: 10px;
    }

    .mgb-m-15 {
        margin-bottom: 15px;
    }

    .eb-col,
    .eb-col button {
        min-width: 50%;
        text-align: center;
        width: 100%;
    }

    .room-title-details {
        padding: 15px
    }

    .room-full-slider img {
        border-radius: 3px;
    }
}
</style>




// WEBPACK FOOTER //
// src/components/roomDetails.vue